module.exports = __webpack_public_path__ + "GR.png?f6533169c3e5c6ca457a05a305990812";